import React from "react";
import { Box, Typography, Avatar, Grid, ListItem, List, Tooltip, capitalize } from "@mui/material";
import RectangleIcon from "@mui/icons-material/Rectangle";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import queryGraphql from "../../helpers/ApiInterface";
interface ClustersTableProps {
	columnFilters: any;
	clusters: any;
	type: any;
	deleteCluster: any;
	resourceStatuses: any;
}
const ClustersTable: React.FC<ClustersTableProps> = ({
	columnFilters,
	clusters,
	type,
	deleteCluster,
	resourceStatuses
}: any) => {
	const [deleteButton, setDeleteButton] = React.useState<boolean>(false);
	const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
	const navigate = useNavigate();

	// const [clustersNew, setClustersNew] = React.useState(clusters);
	// const deleteCluster = async (id: string) => {
	// 	const data = await queryGraphql(
	// 		`
	// 				mutation DeleteCluster($deleteClusterId: String!) {
	//   deleteCluster(id: $deleteClusterId) {
	// 	id
	//   }
	// }
	// `,
	// 		{
	// 			deleteClusterId: id,
	// 		}
	// 	);

	// 	if (data.deleteCluster.id) {
	// 		setClustersNew([...clustersNew.filter((e: any) => e.id != id)]);
	// 	}
	// };
	return (
		// <TableContainer sx={{ boxShadow: 0, marginBottom: 3 }}>
		// 	<Table sx={{ borderCollapse: "separate", borderSpacing: "0px 6px", bgcolor: "#F6F6F6" }}>
		// 		<TableHead>
		// 			<TableRow>
		// 				{columnFilters.clusterName && (
		// 					<TableCell sx={{ color: "#666666" }}>
		// 						<Typography fontSize="12px">CLUSTER NAME</Typography>
		// 					</TableCell>
		// 				)}
		// 				{columnFilters.environment && (
		// 					<TableCell sx={{ color: "#666666" }}>
		// 						<Typography fontSize="12px">ENVIRONMENT</Typography>
		// 					</TableCell>
		// 				)}
		// 				{columnFilters.region && (
		// 					<TableCell sx={{ color: "#666666" }}>
		// 						<Typography fontSize="12px">REGION</Typography>
		// 					</TableCell>
		// 				)}
		// 				{columnFilters.gcpProjectId && (
		// 					<TableCell sx={{ color: "#666666" }}>
		// 						<Typography fontSize="12px">GCP PROJECT ID</Typography>
		// 					</TableCell>
		// 				)}
		// 				{columnFilters.clusterOwner && (
		// 					<TableCell sx={{ color: "#666666" }}>
		// 						<Typography fontSize="12px">OWNER</Typography>
		// 					</TableCell>
		// 				)}
		// 				{columnFilters.applications && (
		// 					<TableCell sx={{ color: "#666666" }}>
		// 						<Typography fontSize="12px">NO. OF APPLICATIONS</Typography>
		// 					</TableCell>
		// 				)}
		// 				{columnFilters.createdAt && (
		// 					<TableCell sx={{ color: "#666666" }}>
		// 						<Typography fontSize="12px">REQUESTED ON</Typography>
		// 					</TableCell>
		// 				)}
		// 			</TableRow>
		// 		</TableHead>
		// 		<TableBody>
		// 			{clusters.map((cluster: any) => (
		// 				<TableRow
		// 					hover
		// 					onMouseEnter={() => setDeleteButton(true)}
		// 					onMouseLeave={() => setDeleteButton(false)}
		// 					key={cluster.id}
		// 					sx={{
		// 						bgcolor:
		// 							type == "active" ? "#FFFFFF" : type == "rejected" ? "#F0443810" : "#FDB02210",
		// 						borderRadius: "20px",
		// 					}}
		// 				>
		// 					{columnFilters.clusterName && (
		// 						<TableCell
		// 							sx={{
		// 								fontWeight: "bold",
		// 								padding: "2px",
		// 							}}
		// 						>
		// 							<Box sx={{ display: "flex", alignItems: "center" }}>
		// 								<RectangleIcon
		// 									sx={{
		// 										color:
		// 											type == "active" ? "#12B76A" : type == "rejected" ? "#F04438" : "#FDB022",
		// 										bgcolor:
		// 											type == "active" ? "#12B76A" : type == "rejected" ? "#F04438" : "#FDB022",
		// 										width: "4px",
		// 										marginRight: "8px",
		// 									}}
		// 								/>
		// 								<Typography fontSize="14px" fontFamily="Gilroy-Medium">
		// 									{cluster.clusterName}
		// 								</Typography>
		// 							</Box>
		// 						</TableCell>
		// 					)}
		// 					{columnFilters.environment && (
		// 						<TableCell>
		// 							{" "}
		// 							<Typography fontSize="14px" fontFamily="Gilroy-Regular">
		// 								{cluster.environment}
		// 							</Typography>
		// 						</TableCell>
		// 					)}
		// 					{columnFilters.region && (
		// 						<TableCell>
		// 							<Typography fontSize="14px" fontFamily="Gilroy-Regular">
		// 								{cluster.region}
		// 							</Typography>
		// 						</TableCell>
		// 					)}
		// 					{columnFilters.gcpProjectId && (
		// 						<TableCell>
		// 							<Typography fontSize="14px" fontFamily="Gilroy-Regular">
		// 								{cluster.gcpProjectId}
		// 							</Typography>
		// 						</TableCell>
		// 					)}
		// 					{columnFilters.clusterOwner && (
		// 						<TableCell>
		// 							<Box sx={{ display: "flex", alignItems: "center" }}>
		// 								<Avatar
		// 									src={cluster.clusterOwnerAvatar}
		// 									alt={cluster.clusterOwner}
		// 									sx={{ marginRight: "8px", height: 30, width: 30 }}
		// 								/>
		// 								<Typography fontSize="14px" fontFamily="Gilroy-Regular">
		// 									{cluster.clusterOwner}
		// 								</Typography>
		// 							</Box>
		// 						</TableCell>
		// 					)}
		// 					{columnFilters.applications && (
		// 						<TableCell>
		// 							<Box sx={{ display: "flex", alignItems: "center" }}>
		// 								<Typography fontSize="14px" fontFamily="Gilroy-Regular">
		// 									{cluster.applications}
		// 								</Typography>
		// 								<Avatar
		// 									src="/assets/info.svg"
		// 									alt="info"
		// 									sx={{ height: 16, width: 16, marginLeft: "4px" }}
		// 								/>
		// 							</Box>
		// 						</TableCell>
		// 					)}
		// 					{columnFilters.createdAt && (
		// 						<TableCell>
		// 							<Box display="flex" alignItems="center" justifyContent="space-between">
		// 								<Typography fontSize="14px" fontFamily="Gilroy-Regular">
		// 									{moment(cluster.createdAt).format("DD/MM/YYYY | hh:mm A")}
		// 								</Typography>
		// 								{/* {!deleteButton && <Box width="40px" height="24px" />}
		// 								{deleteButton && (
		// 									<IconButton
		// 										onClick={() => deleteCluster(cluster.id)}
		// 										sx={{ width: "24px", height: "24px", ml: "16px" }}
		// 									>
		// 										<img src="/assets/delete-plat.svg" />
		// 									</IconButton>
		// 								)} */}
		// 							</Box>
		// 						</TableCell>
		// 					)}
		// 				</TableRow>
		// 			))}
		// 		</TableBody>
		// 	</Table>
		// </TableContainer>
		<List sx={{ bgcolor: "#fafafa" }}>
			<ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
				<Box width="100%">
					<Grid container direction="row" alignItems="center">
						<Grid item xs={2}>
							<Typography fontSize="12px">CLUSTER NAME</Typography>
						</Grid>
						<Grid item xs={1.5}>
							<Typography fontSize="12px">ENVIRONMENT</Typography>
						</Grid>
						<Grid textAlign="start" item xs={1.5}>
							<Typography fontSize="12px">REGION</Typography>
						</Grid>
						<Grid item textAlign="start" xs={2}>
							<Typography fontSize="12px">CLOUD IDENTIFIER</Typography>
						</Grid>
						<Grid item textAlign="start" xs={2}>
							<Typography fontSize="12px">OWNER</Typography>
						</Grid>
						<Grid item textAlign="start" xs={1.5}>
							<Typography fontSize="12px">
								{type == "rejected" ? "REJECTED BY/ REASON" : "NO. OF APPLICATIONS"}
							</Typography>
						</Grid>
						<Grid item textAlign="start" xs={1.5}>
							<Typography fontSize="12px">REQUESTED ON</Typography>
						</Grid>
					</Grid>
				</Box>
			</ListItem>
			{clusters.map((cluster: any, index: number) => (
				<ListItem
					sx={{
						border: cardHoverIndex == index ? "1px solid #000" : "1px solid #00000000",
						mt: 1,

						bgcolor: type == "active" ? "#FFFFFF" : type == "rejected" ? "#F0443810" : "#FDB02210",
						borderRadius: "8px",
						cursor: "pointer",
					}}
					onMouseEnter={() => setCardHoverIndex(index)}
					onMouseLeave={() => {
						setCardHoverIndex(null);
					}}
					onClick={() => {
						navigate(`/clusters/details/${cluster.id}`);
					}}
				>
					<Box width="100%" sx={{}}>
						<Grid container direction="row" alignItems="center" justifyContent="space-between">
							<Grid item xs={2}>
								{columnFilters.clusterName && (
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<RectangleIcon
											sx={{
												color:
													type == "active" ? "#12B76A" : type == "rejected" ? "#F04438" : "#FDB022",
												bgcolor:
													type == "active" ? "#12B76A" : type == "rejected" ? "#F04438" : "#FDB022",
												width: "4px",
												marginRight: "8px",
											}}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Medium">
											{cluster.clusterName}
										</Typography>
										{/* {cluster.status == 'active' ? (<Tooltip
												sx={{ whiteSpace: "pre-line" }}
												title={
													<Box>
														Applications
														<br />
														{cluster.applications?.map((e: any, index: number) => (
															<React.Fragment key={index}>
																{`${index + 1}. ${e.applicationName}`}
																<br />
															</React.Fragment>
														))}
													</Box>
												}
												><Avatar
												src="/assets/info.svg"
												alt="info"
												sx={{ height: 16, width: 16, marginLeft: "4px" }}
											/> </Tooltip>) : null} */}
											{cluster && cluster.status === 'active' ? ( 
  <Tooltip
    sx={{ whiteSpace: "pre-line" }}
    title={
      <Box key="applications-tooltip"> 
        Current Status
        <br />
		{resourceStatuses.filter((e:any) => e.resourceId == cluster.id).map((e: any, index: number) => (
          <React.Fragment key={index}>
            {capitalize(e.currentStatus)}
            <br />
          </React.Fragment>
        ))}
		
      </Box>
    }
  >
    <Avatar
      src="/assets/info.svg"
      alt="info"
      sx={{ height: 16, width: 16, marginLeft: "4px" }}
    />
  </Tooltip>
) : null}

									</Box>
								)}
							</Grid>
							<Grid item xs={1.5}>
								{columnFilters.environment && (
									<Typography fontSize="14px" fontFamily="Gilroy-Regular">
										{cluster.environment}
									</Typography>
								)}
							</Grid>
							<Grid item xs={1.5}>
								{columnFilters.region && (
									<Typography fontSize="14px" fontFamily="Gilroy-Regular">
										{cluster.region}
									</Typography>
								)}
							</Grid>
							<Grid item xs={2}>
								{columnFilters.gcpProjectId && (
									<Typography fontSize="14px" fontFamily="Gilroy-Regular">
										{cluster.gcpProjectId}
									</Typography>
								)}
							</Grid>
							<Grid item xs={2}>
								{columnFilters.clusterOwner && (
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<Avatar
											src={cluster.clusterOwnerAvatar}
											alt={cluster.clusterOwner}
											sx={{ marginRight: "8px", height: 30, width: 30 }}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{cluster.clusterOwner}
										</Typography>
									</Box>
								)}
							</Grid>
							<Grid item xs={1.5}>
								{columnFilters.applications && type == "active" && (
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{cluster.applications?.length || 0}
										</Typography>
										{cluster.applications?.length > 0 && (
											<Tooltip
												sx={{ whiteSpace: "pre-line" }}
												// title={cluster.applications?.map(
												// 	(e: any, index: number) => `${e.applicationName}`
												// )}
												title={
													<>
														Applications
														<br />
														{cluster.applications?.map((e: any, index: number) => (
															<>
																{`${index + 1}. ${e.applicationName}`}
																<br />
															</>
														))}
													</>
												}
											>
												<Avatar
													src="/assets/info.svg"
													alt="info"
													sx={{ height: 16, width: 16, marginLeft: "4px" }}
												/>
											</Tooltip>
										)}
									</Box>
								)}
								{columnFilters.applications && type == "rejected" && (
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<Avatar
											src={cluster.clusterApprover?.googleProfilePicture}
											alt={cluster.clusterApprover?.name}
											sx={{ marginRight: "8px", height: 30, width: 30 }}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{cluster.clusterApprover?.name}	
										</Typography>
										<Tooltip
											sx={{ whiteSpace: "pre-line" }}
											// title={cluster.applications?.map(
											// 	(e: any, index: number) => `${e.applicationName}`
											// )}
											title={
												<>
													Reason of Rejection
													<br />
													{cluster.reasonForRejection || ""}
												</>
											}
										>
											<Avatar
												src="/assets/info.svg"
												alt="info"
												sx={{ height: 16, width: 16, marginLeft: "4px" }}
											/>
										</Tooltip>
									</Box>
								)}
							</Grid>
							<Grid item xs={1.5}>
								{columnFilters.createdAt && (
									<Box display="flex" alignItems="center" justifyContent="space-between">
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{moment(cluster.createdAt).format("DD/MM/YYYY | hh:mm A")}
										</Typography>
										{/* {!deleteButton && <Box width="40px" height="24px" />}
										{deleteButton && (
											<IconButton
												onClick={() => deleteCluster(cluster.id)}
												sx={{ width: "24px", height: "24px", ml: "16px" }}
											>
												<img src="/assets/delete-plat.svg" />
											</IconButton>
										)} */}
									</Box>
								)}
							</Grid>
						</Grid>
					</Box>
				</ListItem>
			))}
		</List>
	);
};

export default ClustersTable;
